import { Route, RouteObject } from 'react-router-dom';
import PhotoMeterReads from './components/PhotoMeterReads/landing/PhotoMeterReads';
import PhotoReadView from './components/PhotoMeterReads/PhotoReadView';
import ManualMeterReads from './components/ManualMeterReads/ManualMeterReads';
import PhotoReadDetail from './components/PhotoMeterReads/detail/PhotoReadDetail';

export interface mxMeterReadsRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: mxMeterReadsRoute[];
}

export const mxMeterReadsRoutes: mxMeterReadsRoute[] = [
  {
      path: 'mx/meterread/photo-meter',
      element: <PhotoMeterReads />,
  },
  {
    path: 'mx/meterread/photo-meter/:id',
    element: <PhotoReadDetail />
  },
  {path: "mx/meterread/manual-meter", element: <ManualMeterReads />},
  // {path: "mx/read-cycles/edit/:id", element: <ReadCycleCreate />},
  // {path: "mx/read-cycles/create", element: <ReadCycleCreate />}
]